import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { LocalModel } from 'src/app/shared/models/LocalModel.model';
import { LocalsListModel } from 'src/app/shared/models/LocalsListModel.model';
import { FiltersModel } from 'src/app/shared/models/FiltersModel.model';
import { CreateLocalModel } from 'src/app/shared/models/CreateLocalModel.model';

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  private userToken: string;

  constructor(private http: HttpClient, private authenticationService: AuthenticationService) {
    const $this = this;
    $this.userToken = $this.authenticationService.currentUserValue.Token;
  }


  public GetAllColumnNames(): Observable<string[]> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.get<string[]>(environment.apiUrl + 'api/v1/Local/GetAllColumnNames', header).pipe();
  }

  public GetAllLocals(filterParameters: FiltersModel): Observable<LocalsListModel> {
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + $this.userToken)
    }

    return $this.http.post<LocalsListModel>(environment.apiUrl + 'api/v1/Local/GetAllLocals', filterParameters, header).pipe();
  }

  public DeleteListOfLocals(listOfDocuments: any[]): Observable<any> {
    const $this = this;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + $this.userToken),
      body: listOfDocuments,
    };
    return $this.http.delete<any>(environment.apiUrl + 'api/v1/Local', options).pipe();
  }

  public GetLocalById(id:number): Observable<LocalModel>{
    const $this = this;

    var header = {
      headers: new HttpHeaders()
        .set('Authorization',  'Bearer ' + $this.userToken)
    }

    return $this.http.get<LocalModel>(environment.apiUrl + 'api/v1/Local/' + id, header).pipe();
  }

  public SaveLocal(argLocalData: CreateLocalModel): Observable<string> {

    const $this = this;

    return $this.http.post<string>(environment.apiUrl + 'api/v1/Local', argLocalData).pipe();

  }

  public GetKioskLocal(argKioskId: number): Observable<any> {

    const $this = this;

    return $this.http.get<any>(environment.apiUrl + 'api/v1/Kiosk/GetKioskLocal/' + argKioskId).pipe();

  }
}
